import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function SharedDna() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("nxt_ref", code);
    api.get(`/dna/public/${code}`).then(({ data }) => setData(data)).catch(() => setNotFound(true));
  }, [code]);

  if (notFound) return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <p className="font-display text-2xl font-bold">This link isn't available</p>
      <button onClick={() => navigate("/signup")} className="rounded-full bg-indigo-600 px-6 py-3 font-bold text-white">Discover your Career DNA</button>
    </div>
  );
  if (!data) return <div className="flex min-h-screen items-center justify-center bg-slate-950"><Loader2 className="h-8 w-8 animate-spin text-white" /></div>;

  const w = data.wrapped;
  const rows = [
    { label: "Career Archetype", value: w.archetype },
    { label: "Superpower", value: w.superpower },
    { label: "Best Career Match", value: w.best_match },
    { label: "Compatibility", value: `${w.compatibility}%`, big: true },
  ];

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-slate-950 to-indigo-950 px-5 py-10 text-white">
      <p className="mb-5 text-center text-white/70"><span className="font-bold text-white">{data.owner_name}</span> decoded their Career DNA on NxT</p>
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className={`aspect-[9/16] w-full max-w-xs overflow-hidden rounded-[28px] bg-gradient-to-br ${w.color} p-6 shadow-2xl`}>
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/60">Career Wrapped · {w.year}</div>
        <div className="mt-6 space-y-4">
          {rows.map((r) => (
            <div key={r.label}>
              <div className="text-[9px] font-bold uppercase tracking-[0.2em] text-white/50">{r.label}</div>
              <div className={`font-display font-extrabold leading-tight ${r.big ? "text-4xl text-amber-300" : "text-xl"}`}>{r.value}</div>
            </div>
          ))}
        </div>
      </motion.div>
      <div className="mt-8 text-center">
        <p className="font-display text-2xl font-extrabold">Discover your Career DNA</p>
        <p className="mt-1 text-white/60">Free · 7 minutes · Find the careers that fit you</p>
        <button onClick={() => navigate("/signup")} data-testid="shared-cta-btn"
          className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 font-bold text-slate-900 transition-all hover:bg-white/90 active:scale-95">
          Discover Your Career DNA <ArrowRight className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
